<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header -->
      <b-navbar class="p-0" toggleable="lg" :type="isDark ? 'dark' : 'light'" :variant="isDark ? 'dark' : 'light'">
        <b-navbar-brand class="ml-4">
          <strong>Usuários</strong>
          <small> Lista</small>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button class="px-2" type="button" :variant="isDark ? 'dark' : 'light'" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-question-circle"></i></span>
              </b-button>  
              
              <b-button class="px-2" type="reset" :variant="isDark ? 'dark' : 'light'" @click.stop.prevent="limparFiltro()">
                <span style="font-size: 1.2rem" > <i  class="fa fa-ban"></i></span>
              </b-button>                            
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarHtml()" title="Imprimir/HTML" v-b-tooltip.hover.bottom> 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-print"></i></span>
              </b-button>
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarExcel()" title="Exportar Excel" v-b-tooltip.hover.bottom> 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-file-excel-o"></i></span>
              </b-button>
              <b-button class="px-2" :variant="isDark ? 'dark' : 'light'" type="button" @click.stop.prevent="exportarCsv()" title="Exportar CSV" v-b-tooltip.hover.bottom> 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-file-text-o"></i></span>
              </b-button>
             
              <b-form-input type="text" id="nome" ref="nome"
                            placeholder="Informe o Nome ou CPF" 
                            v-model="nome"
                            @keydown.enter="pesquisar()"
                            class="ml-2 bg-white"> </b-form-input>
              <b-button class="ml-2" pill type="button" :disabled="isBusy" variant="primary" @click.stop.prevent="pesquisar()">
                <b-icon icon="search" aria-hidden="true"></b-icon> Filtrar
              </b-button>
              <div class="d-inline-block">                              
                <b-button ref="btAdicionar" class="ml-2" pill variant="teal" type="button" @click.stop.prevent="novo()" > 
                  <b-icon icon="plus" aria-hidden="true" font-scale="1.2"></b-icon> Adicionar Novo
                </b-button>
              </div>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="p-0">
           
          <b-table 
                  class="table table-sm mb-2"
                  id="table-transition-example"
                  ref="tbl"
                  :busy.sync="isBusy" 
                  :items="itensFiltrados" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-clicked="selecionarLinha"
                  @row-dblclicked="edit"
                  :sticky-header="stickyHeight"
                  :tbody-tr-class="rowClassSelecionado"
                  :head-variant="isDark ? 'dark' : 'light'"
                  :dark="isDark"
                  hover 
                  small 
                  bordered 
                  show-empty
                  empty-text="Informe o filtro para ver os registros "
                  responsive 
                  >
            <template #head(ID)>
              <SetFilter
                label="ID"
                v-model="filtros.ID"
                :options="opcoes.ID"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>      
            <template #head(CPF)>
              <SetFilter
                label="CPF/Login"
                v-model="filtros.CPF"
                :options="opcoes.CPF"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(STATUS)>
              <SetFilter
                label="Situação"
                v-model="filtros.STATUS"
                :options="opcoes.STATUS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
                
            <template #cell(ID)="item">{{item.item.ID}}</template>
            <template #cell(CPF)="item">{{item.item.CPF}}</template>
            <template #cell(STATUS)="item">
              <b-badge  :variant="colorirStatus(item.item)">{{traduzirSituacao(item.item)}}</b-badge>
            </template>
            <template #cell(actions)="item">
              <b-button type="button" @click.stop.prevent="abrirModalSenha(item.item)" size="sm" variant="warning" class="mr-1" title="Alterar Senha" v-b-tooltip.hover>
                <i class="fa fa-key"></i>
              </b-button>
              <b-button type="button" @click.stop.prevent="excluir(item.item)" size="sm" variant="danger " >
                <i class="fa fa-times"></i>
              </b-button>
            </template>
          </b-table>
          
        </b-col>
      </b-row>
      
      <!-- Modal de Confirmação para Resultado Grande -->
      <b-modal ref="modalConfirmacao" 
               title="Muitos Registros Encontrados" 
               hide-header-close
               no-close-on-backdrop
               no-close-on-esc
               @shown="onModalShown"
               @hidden="onModalHidden">
        <p>
          A pesquisa retornou <strong>{{ resultadoPendenteCount }}</strong> registros.
        </p>
        <p>
          Deseja carregar todos os registros? Isso pode deixar a aplicação lenta.
        </p>
        
        <template #modal-footer>
          <div class="w-100 d-flex justify-content-end align-items-center">
            <small class="text-muted mr-auto">
              <b-icon icon="x-circle" aria-hidden="true"></b-icon>
              Pressione [ESC] para cancelar
            </small>
            <b-button ref="btnCancelar" 
                      variant="secondary" 
                      @click="cancelarCarregarResultadoGrande">
              Cancelar
            </b-button>
            <b-button variant="primary" 
                      class="ml-2" 
                      @click="confirmarCarregarResultadoGrande">
              Sim, Carregar
            </b-button>
          </div>
        </template>
      </b-modal>
      
      <!-- Modal Alterar Senha (Premium Pattern) -->
      <b-modal ref="modalSenha" 
               id="modalSenha" 
               hide-header
               hide-footer
               body-class="p-0 overflow-hidden"
               content-class="border-0 shadow-lg"
               centered
               size="md"
               @shown="onModalSenhaShown">
        
        <!-- Cabeçalho Premium -->
        <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" 
             style="background: linear-gradient(135deg, #f0ad4e 0%, #df8a13 100%) !important;">
          <div class="header-icon-wrapper mr-3 bg-white-10">
            <i class="fa fa-key text-white"></i>
          </div>
          <div>
            <h5 class="mb-0 font-weight-bold text-white">Alterar Senha</h5>
            <small class="text-white opacity-75">Defina uma nova senha de acesso</small>
          </div>
          <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs.modalSenha.hide()">
            <i class="fa fa-times fa-lg"></i>
          </b-button>
        </div>

        <div class="p-4">
          <!-- Barra de Info -->
          <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
            <b-row align-v="center">
              <b-col md="12">
                <small class="modal-label-premium">Usuário</small>
                <h5 class="mb-0 font-weight-bold text-dark">{{ usuarioSelecionado.CPF }}</h5>
              </b-col>
            </b-row>
          </div>

          <b-form @submit.stop.prevent="salvarSenha">
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label class="modal-label-premium">Nova Senha</label>
                  <b-form-input 
                    type="password" 
                    ref="inputSenha"
                    v-model="senhaForm.novaSenha" 
                    class="rounded-pill shadow-xs"
                    placeholder="Digite a nova senha"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label class="modal-label-premium">Confirmar Senha</label>
                  <b-form-input 
                    type="password" 
                    v-model="senhaForm.confirmaSenha" 
                    class="rounded-pill shadow-xs"
                    placeholder="Confirme a nova senha"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </div>

        <!-- Rodapé Premium -->
        <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$refs.modalSenha.hide()">
            CANCELAR
          </b-button>
          <b-button variant="warning" pill class="px-5 font-weight-bold shadow-sm" :disabled="processandoSenha" @click="salvarSenha">
            <i class="fa fa-check-circle mr-1" v-if="!processandoSenha"></i>
            <b-spinner small v-else></b-spinner>
            ALTERAR SENHA
          </b-button>
        </div>
      </b-modal>
      
    </div>  
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: {
    SetFilter
  },

  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'CPF', type: 'string', label: 'CPF' },
      { key: 'STATUS',   type: 'string', label: 'Situação',
        labelMap: { 'A': 'ATIVO', 'I': 'INATIVO' } }
    ]
  })],
  data () {
    return {
      isLoading: false,
      status: '',
      isBusy: false,
      fields: [
        { key: "ID", label: 'Id', sortable: true,  class:'align-middle text-right', thStyle: { width: "10%" }},
        { key: "CPF", label: 'CPF/Login', sortable: true, class:'align-middle', thStyle: { width: "75%" }},
        { key: "STATUS", label: 'Situação', sortable: true, class:'align-middle text-center', thStyle: { width: "10%" }},
        { key: "actions", label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: "5%" }}
      ],
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      
      // Senha Modal Data
      usuarioSelecionado: {},
      senhaForm: {
        novaSenha: '',
        confirmaSenha: ''
      },
      processandoSenha: false
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    id: {
      get () {
        return this.$store.getters['usuario/ID']
      }, 
      set (value) {
        this.$store.commit("usuario/SET_ID", value);
      }
    },
    nome: {
      get () {
        return this.$store.getters['usuario/NOME']
      }, 
      set (value) {
        this.$store.commit("usuario/SET_NOME", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['usuario/PER_PAGE']
      }, 
      set (value) {
        this.$store.commit("usuario/SET_PER_PAGE", value);
      }
    },
    currentPage: {
      get () {
        return this.$store.getters['usuario/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("usuario/SET_PAGINA_ATUAL", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['usuario/LISTA']
      }, 
    },
  },
  methods: {
    selecionarLinha(item) {
      this.$store.commit("usuario/SET_REGISTRO_SELECIONADO_ID", item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['usuario/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    colorirStatus(linha) { 
      if (linha.STATUS == 'I') return 'danger'
      else return 'success'
    },
    traduzirSituacao(linha) { 
      if (linha.STATUS == 'I') return 'INATIVO'
      else return 'ATIVO'
    },
    limparFiltro() {
      this.nome = null
      this.id = null
      this.$store.commit('usuario/SET_LIMPAR')
    },
    edit (item) {
      this.$router.push(`/seguranca/usuario/edit/${item.ID}`)
    },
    novo () {
      this.$router.push(`/seguranca/usuario/add`)
    },
    async pesquisar (ctx) {
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      try {
        this.isLoading = true
        this.isBusy = true
        
        const inputElement = this.$refs.nome
        if (inputElement && inputElement.$el) {
          inputElement.$el.blur()
        } else if (inputElement) {
          inputElement.blur()
        }
        
        const result = await this.$store.dispatch('usuario/GERAR_LISTA')
        
        if (result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.$refs.modalConfirmacao.show()
          return
        }
        
      } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao pesquisar usuários!')
      } finally {
        this.isBusy = false
        this.isLoading = false
        this.status = true 
      }
    },
    async excluir(item) {
      try {
        await this.$bvModal.msgBoxConfirm(`Deseja realmente excluir o usuário ${item.CPF}?`, {
          title: 'Exclusão de Usuário',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(async (value) => {
            if (value) {
                const payload = {
                    usuarioId: item.ID,
                    login: window.localStorage.getItem('login'),
                    motivo: 'Exclusão pelo sistema' 
                }
                
                await this.$http.post(`/api/protected/usuario/delete`, payload)
                Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Usuário excluído com sucesso!')
                await this.pesquisar()
            }
        })
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao excluir usuário!')
      }
    },
    confirmarCarregarResultadoGrande() {
      this.$refs.modalConfirmacao.hide()
      if (this.resultadoPendente) {
        this.$store.commit('usuario/SET_LISTA', this.resultadoPendente)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      this.$refs.modalConfirmacao.hide()
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
    },
    onModalShown() {
      this.modalConfirmacaoAberto = true
    },
    onModalHidden() {
      this.modalConfirmacaoAberto = false
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Listagem de Usuários',
        printedBy: window.localStorage.getItem('login') ?? '—',
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'usuarios.html',
      });
    },
    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'usuarios.xlsx',
      });
    },
    exportarCsv() {
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.fields.filter(f => f.key !== 'actions'),
        filename: 'usuarios.csv',
      });
    },

    // Password Change Methods
    abrirModalSenha(usuario) {
      this.usuarioSelecionado = usuario
      this.senhaForm.novaSenha = ''
      this.senhaForm.confirmaSenha = ''
      this.$refs.modalSenha.show()
    },
    onModalSenhaShown() {
      if (this.$refs.inputSenha) {
        this.$refs.inputSenha.focus()
      }
    },
    async salvarSenha() {
      if (!this.senhaForm.novaSenha) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a nova senha!')
        return
      }
      if (this.senhaForm.novaSenha !== this.senhaForm.confirmaSenha) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'As senhas não conferem!')
        return
      }

      this.processandoSenha = true
      try {
        const payload = {
          usuarioId: this.usuarioSelecionado.ID,
          novaSenha: this.senhaForm.novaSenha,
          login: window.localStorage.getItem('login')
        }

        await this.$http.post('/api/protected/usuario/alterar-senha', payload)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Senha alterada com sucesso!')
        this.$refs.modalSenha.hide()
      } catch (err) {
        const msg = err.response?.data || err.message || 'Erro ao alterar a senha'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', msg)
      } finally {
        this.processandoSenha = false
      }
    }
  },
  async created() {
    const listagem = this.$store.getters['usuario/LISTA']
    if (!listagem.length) {
      await this.pesquisar()
    }
  }
}
</script>
<style >
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

.b-table-sticky-header .table-responsive {
  max-height: inherit;
  overflow-y: auto;
}

.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000 !important;
}

.table.b-table tbody tr.cec-row-selected a {
  color: #000 !important;
}

.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6 !important;
}

.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #adbac3 !important;
}

/* Premium Modal Styles */
.modal-header-premium {
    border-bottom: none;
}
.header-icon-wrapper {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 1.5rem;
}
.bg-white-10 {
    background-color: rgba(255, 255, 255, 0.15) !important;
}
.modal-section-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #2d3748;
    border-bottom: 2px solid #edf2f7;
    padding-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.modal-label-premium {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
    margin-bottom: 0.4rem;
    display: block;
}
.shadow-xs {
    box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}
.btn-soft-danger {
    background-color: rgba(248, 108, 107, 0.1);
    color: #f86c6b;
    border: none;
}
.btn-soft-danger:hover {
    background-color: #f86c6b;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/seguranca/usuario/UsuarioListagem.vue